const maxLength = 35;
const suffixLength = 10;

export default function anchor(
  href: string | null,
  text: string,
  key?: string | number,
): string {
  let linkText = text;
  let cleanText = text;
  let validHref = href;

  const regResult = /\[([\w\W]+)]\s*\(([\w\\/.,%&#?=:-]+)\)/.exec(text);
  if (regResult) {
    const [, markdownText, markdownHref] = regResult;
    cleanText = markdownText;
    validHref = markdownHref.includes('http')
      ? markdownHref
      : 'http://'.concat(markdownHref);
  }

  if (text.length > maxLength) {
    const prefixLength = maxLength - suffixLength - 3;
    const prefix = text.substring(0, prefixLength);
    const suffix = text.substring(text.length - suffixLength, text.length);
    linkText = `${prefix}...${suffix}`;
  }

  const keyAttr = key ? ` key="${key}"` : '';

  return `<a href="${validHref || href}"${keyAttr} target="_blank" rel="noopener noreferrer">${cleanText || linkText}</a>`;
}
